// extracted by mini-css-extract-plugin
module.exports = {"button":"_256NRn"};